// dynamic-header.component.ts
import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewContainerRef, ComponentFactoryResolver, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NetworkSummaryHeaderComponent } from '../headers/network-summary-header/network-summary-header.component';
import { DefaultHeaderComponent } from './default-header/default-header.component';
import { RegionHeaderComponent } from '../headers/region-header/region-header.component';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-dynamic-header',
  standalone: true,
  imports: [CommonModule],
  template: '',
})
export class DynamicHeaderComponent implements OnInit {
  private router = inject(Router);
  private viewContainerRef = inject(ViewContainerRef);
  private cfr = inject(ComponentFactoryResolver);

  ngOnInit(): void {
    this.loadHeaderComponent(this.router.url);
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.loadHeaderComponent(this.router.url);
    });
  }

  async loadHeaderComponent(url: string) {
    this.viewContainerRef.clear();
    let component: any;

    // if (url.startsWith('/region')) {
    // Check if the URL starts with '/region' to handle dynamic segments like /region/1/dpd-guildford
    // component = RegionHeaderComponent;
    // } else {
    switch (url) {
      case '/network-summary':
        component = NetworkSummaryHeaderComponent;
        break;
      default:
        component = DefaultHeaderComponent;
    }
    // }

    if (component) {
      const factory = this.cfr.resolveComponentFactory(component);
      this.viewContainerRef.createComponent(factory);
    }
  }

}
